import {SubmissionErrors} from 'final-form';

export class PersonSubmissionError extends Error {
  constructor(readonly submissionErrors: SubmissionErrors) {
    super('Person submission failed');
  }
}
